import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Flag from 'react-flags';

import axios from 'axios';

import styles from './TalentCard.module.css';
import LinkWrapper from '../../../../wrappers/LinkWrapper';
import BasicPopup from '../../../Popups/BasicPopup/BasicPopup';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import CreateFavListForm from '../CreateFavList/CreateFavListForm';
import user_image_placeholder from '../../../../../assets/images/other/user_avatar_placeholder.png';
import { getTimeAgo } from '../../../../../utils/formatHelpers';
import { getFavoriteTalents } from '../../../../../services/TalentsService';
import {
    BriefcaseWhite,
    ClockBlue,
    GenderIcon,
    LanguageIcon,
    PasportIcon,
    Relocate,
    SaveBookMark,
    SaveIcon,
    TaskDone,
    VerifyGreenBadge,
    WorkHistory
} from '../../../../../assets/images/icons';
import i18next from 'i18next';
import { createChatroom } from '../../../../../services/chatService';
import { useNavigate } from 'react-router-dom';

function TalentCard({ disabled, favTalents, setFavTalents, setTalents, setCount, setTotalPages, setLoading, setPaginationLoading, page, per_page, filters, talent, ...props }) {
    const { t } = useTranslation();
    const user = useSelector(state => state.user.user);
    const skills = useSelector((state) => state.user.skills);

    const [createList, setcreateList] = useState(false);
    const currentLanguage = i18next.language;

    let additional_card_classes = '';
    if (disabled) {
        additional_card_classes = styles.disabled;
    }

    if (talent.hidden) {
        additional_card_classes += ' ' + styles.hidden;
    }

    if (talent.verification_status) {
        additional_card_classes += ' ' + styles.verified;
    }

    let logic_test_bar_color = '';

    switch (true) {
        case talent.logic_test_result >= 8:
            logic_test_bar_color = '#34A853';
            break;
        case talent.logic_test_result >= 6:
            logic_test_bar_color = '#AEB930';
            break;
        case talent.logic_test_result >= 4:
            logic_test_bar_color = '#F2C94C';
            break;
        case talent.logic_test_result >= 2:
            logic_test_bar_color = '#F2884C';
            break;
        default:
            logic_test_bar_color = '#EA4335';
            break;
    }

    let last_seen = '';
    let is_online = false;
    const date_info = getTimeAgo(new Date(talent.last_visit));

    if (date_info.unit_plural !== 'month' && date_info.unit_plural !== 'months' && date_info.unit_plural !== 'year' && date_info.unit_plural !== 'years') {

        if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds' || date_info.unit_plural === 'minute' || (date_info.unit_plural === 'minutes' && date_info.count < 5)) {
            last_seen = t('general.UI.online');
            is_online = true;
        }
        else {
            last_seen = t('employer.subscription_form.active') + ' ' + date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
        }

    }
    const profileDataUI = (icon, title, desc) => {
        return (
            <div className={styles.profileDataContainer}>
                <div>

                    <div className={styles.dataIconContainer}>
                        <img src={icon} alt={`profile data icon`}
                            className={styles.profileDataIcon}
                        />
                    </div>
                </div>
                <div className={styles.col}>
                    <p className={styles.profileDataTitle}>{title}</p>
                    {desc !== 'login_test' ?
                        <p className={styles.profileDataValue}>{desc}</p> :
                        talent.logic_test_result && (
                            <div className={`${styles.col} ${styles.workTest}`} >
                                <p className={styles.profileDataValue}>{talent.logic_test_result * 10}%</p>
                                <div className={styles.card_head_test}>
                                    <span style={{ width: (talent.logic_test_result * 10) + '%', backgroundColor: logic_test_bar_color }}></span>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }

    const isSaved = favTalents?.findIndex((e) => e.talent_id == talent.id)

    const handleSavedTalent = async () => {
        if (isSaved == -1) {
            handlePopupOpen()
        }
        else {
            await axios.post(`${process.env.REACT_APP_API_URL}talents/favorites/add`, {
                userId: user.id,
                talentId: talent.id,
                listIds: [],
            });
            const response = await getFavoriteTalents(user.id, page, per_page, filters)
            setFavTalents(response.talents)


            setTalents(response.talents.map((talent) => {

                if (talent.languages) {
                    talent.languages = talent.languages.map((language) => {
                        return {
                            ...language,
                            id: talent.user_id + '-' + language.languageCode
                        };
                    });
                }

                if (talent.skills) {
                    talent.skills = talent.skills.map((skill) => {

                        let skillData = skills?.filter((e) => e.value == skill.skill_code)[0]

                        if (skills.length > 0 && skillData && Object.keys(skillData)?.length > 0) {
                            return {
                                ...skill,
                                code: currentLanguage === "en" ? skillData.labelen : skillData.labelar,
                                id: skill.user_id + '-' + skill.skill_code
                            }
                        }
                        else {
                            return {
                                ...skill,
                                code: skill.skill_code,
                                id: skill.user_id + '-' + skill.skill_code
                            }
                        };
                    });
                }
                return talent;
            }));
            setCount(response.total);
            setTotalPages(response.totalPages);
            setLoading(false);
            setPaginationLoading(false);


        }
    }
    const handlePopupClose = (popupName) => { setcreateList(false); }
    const handlePopupOpen = (popupName) => { setcreateList(true); }
    const navigate = useNavigate();

    return (
        <div className={`${styles.card} ${additional_card_classes}`} {...props}>

            <div className={styles.cartHeader}>
                <div className={styles.profileSection}>
                    <div >
                        <div className={styles.profileContainer}>
                            {talent.profile_image ? (
                                <LinkWrapper to={`/jobseekers/${talent.slug}`}>
                                    <img src={talent.hide_Profile_Picture ? user_image_placeholder : process.env.REACT_APP_UPLOADS_PATH + talent.profile_image} alt={`${talent.first_name} ${talent.last_name}`}
                                        className={talent.hide_Profile_Picture ?styles.profileImg  : talent.hide_Profile_Picture ? `${styles.blurImage} ${styles.profileImg}` : styles.profileImg}
                                        onError={(e) => {
                                            e.target.onerror = null; // Prevent infinite loop
                                            e.target.src = user_image_placeholder; // Set fallback image
                                        }}
                                    />
                                </LinkWrapper>
                            ) : (
                                <LinkWrapper to={`/jobseekers/${talent.slug}`}>
                                    <img src={user_image_placeholder} alt={`${talent.first_name} ${talent.last_name}`}
                                        className={talent.hide_Profile_Picture ? `${styles.blurImage} ${styles.profileImg}` : styles.profileImg} />
                                </LinkWrapper>
                            )}
                        </div>

                    </div>
                    <div className={styles.aboutUseSection}>
                        <LinkWrapper to={`/jobseekers/${talent.slug}`} style={{ textDecorationLine: 'none' }}>

                            <div className={styles.row}>
                                <p className={styles.userName}>{talent.first_name} {talent.last_name}</p>
                                {talent.verification_status &&
                                    <img src={VerifyGreenBadge} alt={`profile data icon`} />
                                }
                            </div>
                            <div className={styles.flagContainer}>
                                {talent.country && <div>
                                    <Flag
                                        name={talent.country}
                                        format="svg"
                                        shiny={false}
                                        basePath="/vendor/flags"
                                    />
                                    <span>{t('general.country.' + talent.country)}</span>
                                </div>}
                                <div className={styles.saperator}></div>
                                {talent.nationality && <div>
                                    <img src={PasportIcon} alt={`pasport icon`}
                                        className={styles.icon}
                                    />
                                    <span>{t('general.nationality.' + talent.nationality)}</span>
                                </div>}
                                <div className={styles.saperator}></div>
                                {talent.gender && <div>
                                    <img src={GenderIcon} alt={`pasport icon`}
                                        className={styles.icon}
                                    />
                                    <span>{talent.gender}</span>
                                </div>}

                            </div>
                        </LinkWrapper>
                    </div>
                </div>
                <div className={styles.contactSection}>
                    <div className={styles.onlineWrapper}>
                        {is_online && styles.online ?
                            <>
                                <div className={styles.greenCircle}></div>
                                <p className={styles.online}>{t('TalentCard.online')}</p>
                            </>
                            :

                            last_seen &&
                            <>
                                <img src={ClockBlue} alt={`pasport icon`} />
                                <span className={`${styles.last_seen} ${is_online && styles.online}`}>{last_seen}</span>
                            </>
                        }


                    </div>
                    <div className={styles.contactButtonWrapper}>
                        <BubbleButton to={`/jobseekers/${talent.slug}`} headerButton style={{ width: '100px' }} >{t('TalentCard.contact')}</BubbleButton>
                        {user.account_type == 'employer' &&
                            <BubbleButton
                                dark
                                headerDarkButton
                                style={{ width: '100px' }}
                                onClick={async () => {
                                    if (user.account_type == 'employer') {
                                        await createChatroom(user.id, talent.id);
                                        navigate('/chat', {
                                            state: {
                                                employerId: user.id,
                                                jobSeekerId: talent.id,
                                            }
                                        })
                                    }

                                }}
                            >{t('TalentCard.message')}</BubbleButton>
                        }
                    </div>
                </div>
            </div>

            {(talent.hidden && user) && <BubbleButton to="/profile/billing" dark headerDarkButton className={styles.access_button}>{t('job_seeker.upgrade_subscription_plan')}</BubbleButton>}
            {(talent.hidden && !user) && <BubbleButton to="/login" dark headerDarkButton className={styles.access_button}  >{t('job_seeker.create_account_for_access')}</BubbleButton>}
            <div className={talent.hidden ? `${styles.cardbody} ${styles.cardbodyBlur}` : `${styles.cardbody} `}>
                <div className={`${styles.cardcol} ${styles.cardcolWithoutPadding}`} >
                    {talent.working_title && profileDataUI(BriefcaseWhite, t('TalentCard.working_title'), talent.working_title)}
                    {profileDataUI(WorkHistory, t('TalentCard.years_of_experience'), talent.years_of_experience)}
                </div>
                <div className={styles.cardcol}>
                    {talent?.jobPreferences?.length > 0 && profileDataUI(BriefcaseWhite, t('TalentCard.looking_for'),
                        `${talent?.jobPreferences[0]?.jobTitles.join(',')} role (${talent?.jobPreferences[0]?.basePay}/${talent?.jobPreferences[0]?.payPeriod})`
                    )}

                    {talent?.jobPreferences?.length > 0 ?
                        profileDataUI(Relocate, t('TalentCard.willing_to_relocate'), talent?.jobPreferences[0].relocation == "No" ? t('TalentCard.relocate_no') : t('TalentCard.relocate_yes')) :
                        profileDataUI(Relocate, t('TalentCard.willing_to_relocate'), t('TalentCard.relocate_no'))}

                </div>
                <div className={styles.cardcol2}>
                    {talent?.languages?.length > 0 && profileDataUI(LanguageIcon, t('TalentCard.languages'),
                        talent?.languages
                            ?.map((language) => t('general.language.' + language.languageCode))
                            .join(", ")
                    )}
                    {profileDataUI(TaskDone, t('TalentCard.work_proficiency'), 'login_test')}
                </div>
            </div>
            <div className={styles.cardFooter}>
                <p className={styles.profileDataValue}>{t('TalentCard.skills') + ':'}</p>
                <p className={styles.profileDataTitle}>
                    {talent?.skills
                        ?.map((skill) => {
                            return (skill.code)
                        })
                        .join(", ")}
                </p>
                <img src={isSaved == -1 ? SaveIcon : SaveBookMark}
                    alt={`save user icon`}
                    onClick={handleSavedTalent}
                    style={{
                        cursor: "pointer",
                        // border: isSaved == -1 ? '0px solid blue' : '1px solid blue',
                        borderRadius: '5px',
                        padding: '3px',
                        height: isSaved == -1 ? "30px" : '30px',
                        width: isSaved == -1 ? "30px" : '30px'
                    }}
                    className={styles.saveIcon}
                />
            </div>
            {createList &&
                <BasicPopup
                    isOpen={createList}
                    closePopup={() => handlePopupClose('workExperience')}
                >
                    <CreateFavListForm userId={user.id}
                        favTalents={favTalents}
                        setFavTalents={setFavTalents}
                        page={page} per_page={per_page} filters={filters}
                        talentId={talent.id}
                        onclose={() => { setcreateList(false) }}
                        onSubmit={(val) => { console.log(val) }}
                    />
                </BasicPopup>
            }
        </div >
    );
}

export default TalentCard;